import { TableBody as Mui4TableBody, TableBodyProps as Mui4TableBodyProps } from '@material-ui/core'
import { default as Mui5TableBody } from '@mui/material/TableBody'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsTableVersion } from './Table'

export type TableBodyProps = Mui4TableBodyProps
/** @deprecated Use TableBodyProps */
export type OsTableBodyProps = TableBodyProps

export const TableBody = forwardRef<HTMLTableSectionElement, TableBodyProps>((props, ref) => {
  const version = useComponentVersion('table')
  switch (version) {
    case OsTableVersion.V2:
      return <Mui5TableBody ref={ref} {...props} />

    default:
      return <Mui4TableBody ref={ref} {...props} />
  }
})
